import C from './pages/common/constantes'

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

export function validateCreditCard(month, year) {
  let currentDate = new Date();
  let currentYear = currentDate.getFullYear();
  let currentMonth = currentDate.getMonth()+1;//comeca em zero
  if (year > currentYear) {
    return true
  } else if(year == currentYear){

    if (month >= currentMonth)
      return true;
    else
      return false;

  }
  return false

}

export function isCaminhoParana(planId) {
  switch(parseInt(planId)){
      case C.PLAN_PRE_MAN_CAM_PARANA_PF:
      case C.PLAN_PRE_AUT_CAM_PARANA_PF:
      case C.PLAN_PRE_MAN_CAM_PARANA_PJ:
      case C.PLAN_PRE_AUT_CAM_PARANA_PJ:
        return true;
      default:
        return false;

    }
}

export function getPaymentMethodId(brand){
    switch(brand){
        case "Visa":
            return 6;
        case "Mastercard":
            return 7;
        case "Diners":
            return 9;
        case 'American Express':
            return 8;
        case 'Elo':
            return 10;
        case 'HiperCard':
            return 11;
        // case 'Hiper':
        //     return 13;
    }
}

export function getCardBrand(cardNumber){
        cardNumber = cardNumber.replace(/[^0-9]/g, '');

        let digit1 = cardNumber.substring(0, 1);
        let digit2 = cardNumber.substring(0, 2);
        let digit3 = cardNumber.substring(0, 3);
        let digit4 = cardNumber.substring(0, 4);
        let digit5 = cardNumber.substring(0, 5);
        let digit6 = cardNumber.substring(0, 6);

        if (cardNumber.length > 2) {
            /*
             * ----* VISA prefix=4* ---- length=13 or 16 (can be 15 too!?!
             * maybe)
             */
            if (digit1 == 4) {
               return "Visa";
            }
            /*
             * ----------* MASTERCARD prefix= 51 ... 55* ---------- length= 16
             */
            else if (digit2 >= 51 && digit2 <= 55 || digit2 == 59) {
                return "Mastercard";
            }

            // * ----* AMEX prefix=34 or 37* ---- length=15
            else if (digit2 == 34 || digit2 == 37) {
                return "American Express";
            }

            /*
             * -----* ENROU prefix=2014 or 2149* ----- length=15
            else if (digit4 == 2014 || digit4 == 2149) {
                return false;//"EN_ROUTE";
            }
             */
            /*
             * -----* DCLUB prefix=300 ... 305 or 36 or 38* ----- length=14
             */
            // else if (digit2 == 36 || digit2 == 38 || (digit3 >= 300 && digit3 <= 305)) {
            //     return "Diners";
            // }
            else if(digit6==636368 ||digit6==438935 ||digit6==504175 ||digit6==451416 ||digit6==509048 ||digit6==509067 ||digit6==509049 ||digit6==509069 ||digit6==509050 ||digit6==509074 ||digit6==509068 ||digit6==509040 ||digit6==509045 ||digit6==509051 ||digit6==509046 ||digit6==509066 ||digit6==509047 ||digit6==509042 ||digit6==509052 ||digit6==509043 ||digit6==636368 ||digit6==509064 ||digit6==509040 ||digit4==5067 ||digit4==4576 ||digit4==4011 || digit5 ==36297 ){

              return "Elo";
            }


        }
        return "";



}

export function isCardValid(cardNumber){
        cardNumber = cardNumber.replace(/[^0-9]/g, '');
        let valid = 0;

        let digit1 = cardNumber.substring(0, 1);
        let digit2 = cardNumber.substring(0, 2);
        let digit3 = cardNumber.substring(0, 3);
        let digit4 = cardNumber.substring(0, 4);

        if (cardNumber.length > 2) {
            /*
             * ----* VISA prefix=4* ---- length=13 or 16 (can be 15 too!?!
             * maybe)
             */
            if (digit1 == 4) {
                if (cardNumber.length == 13 || cardNumber.length == 16)
                    return true;
            }
            /*
             * ----------* MASTERCARD prefix= 51 ... 55* ---------- length= 16
             */
            else if (digit2 >= 51 && digit2 <= 55 || digit2 == 59) {
                if (cardNumber.length == 16)
                    return true;
            }
            /*
             * ----* AMEX prefix=34 or 37* ---- length=15
            else if (digit2 == 34 || digit2 == 37) {
                if (cardNumber.length == 15)
                    valid = "AMERICAN_EXPRESS";
            }
             */
            /*
             * -----* ENROU prefix=2014 or 2149* ----- length=15
            else if (digit4 == 2014 || digit4 == 2149) {
                if (cardNumber.length == 15)
                    valid = "EN_ROUTE";
            }
             */
            /*
             * -----* DCLUB prefix=300 ... 305 or 36 or 38* ----- length=14
             */
            else if (digit2 == 36 || digit2 == 38 || (digit3 >= 300 && digit3 <= 305)) {
                if (cardNumber.length == 14)
                    return true
            }
        }
        return false;

        /*
         * ----* DISCOVER card prefix = 60* -------- lenght = 16* left as an
         * exercise ...
         */

}



// WEBPACK FOOTER //
// ./src/utils.js